import { RefObject, useEffect, useRef, useState } from 'react';

export const useCondensedCrumbs = (
  ref: RefObject<HTMLDivElement>,
  crumbCount: number
) => {
  const [condensedCrumbs, setCondensedCrumbs] = useState(false);

  const prevWidth = useRef(0);
  const prevCrumbCount = useRef(0);
  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const element = ref.current;
      if (!element) return;
      const scrollWidth = element.scrollWidth;
      const containerWidth = element.clientWidth;

      const hasOverflow = containerWidth < scrollWidth;

      // only set condensed if the container is shrinking and there is overflow
      if (
        (prevWidth.current > containerWidth ||
          prevWidth.current === 0 ||
          prevCrumbCount.current !== crumbCount) &&
        hasOverflow
      ) {
        setCondensedCrumbs(true);
      }
      // only set not condensed if the container is growing and there is no overflow
      if (
        (prevWidth.current < containerWidth ||
          prevWidth.current === 0 ||
          prevCrumbCount.current !== crumbCount) &&
        !hasOverflow
      ) {
        setCondensedCrumbs(false);
      }

      prevWidth.current = containerWidth;
      prevCrumbCount.current = crumbCount;
    });
    if (ref.current) {
      observer.observe(ref.current!);
    }
    return () => observer.disconnect();
  }, [ref, crumbCount, condensedCrumbs]);

  return condensedCrumbs;
};
